import type { DefaultNotificationTimes } from 'ab-requestModels/notificationSettings.requestModel';

export class DefaultNotificationTimesFM {
	notifyOnDay: number[] | undefined;

	constructor(model: DefaultNotificationTimes) {
		if (
			model.notifyOnSunday === null
			|| model.notifyOnMonday === null
			|| model.notifyOnTuesday === null
			|| model.notifyOnWednesday === null
			|| model.notifyOnThursday === null
			|| model.notifyOnFriday === null
			|| model.notifyOnSaturday === null
		) {
			return {
				notifyOnDay: undefined,
			};
		}

		return {
			notifyOnDay: [
				model.notifyOnSunday,
				model.notifyOnMonday,
				model.notifyOnTuesday,
				model.notifyOnWednesday,
				model.notifyOnThursday,
				model.notifyOnFriday,
				model.notifyOnSaturday,
			],
		};
	}
}
